import { Fragment } from 'preact'

export default function SourceHeader({ title }) {
    return (
        <Fragment>
            <span className="aa-SourceHeaderTitle">{title}</span>
            <div className="aa-SourceHeaderLine" />
        </Fragment>
    )
}
